import * as bootstrap from 'bootstrap';
import $ from 'jquery';
import './file-input';
import './helpers';
import './accessibility';
import './back-to-top';

$(function() {
    $('.input-group.animated input').focus(function(){
        if($('.input-group.animated label').hasClass('already-active')) {
            $('.input-group.animated label').removeClass('already-active')
        }
        $("label[for='"+$(this).attr('id')+"']").addClass("animate-label");
    });
    $('.input-group.animated input').blur(function(){
        if($('.input-group.animated label').hasClass('already-active')) {
            $('.input-group.animated label').removeClass('already-active')
        }
        if ( $(this).val() === ""){
            $("label[for='"+$(this).attr('id')+"']").removeClass("animate-label");
        }
    });
    // if .app height is less than window height, make main bigger so that footer is at the bottom. SIMPLE NO MARGIN NO PADDING
    const appHeight = $('.app').height();
    const windowHeight = $(window).height();
    const headerHeight = $('header').height();
    const footerHeight = $('footer').height();
    const main = $('main');
    const headerFooterHeight = headerHeight + footerHeight;
    if (appHeight < windowHeight) {
        $(main).css('min-height', `${windowHeight - headerFooterHeight}px`);
    }
})

$(function() {
    $('.header-menu__main-toggle').click(function() {
        $('.header-mobile').toggleClass('active');
        //disable scroll on body
        if ($('.header-mobile').hasClass('active')) {
            $('body').css('overflow', 'hidden');
        } else {
            $('body').css('overflow', 'auto');
        }
    })
    $('.header-mobile .menu-item-has-children').click(function() {
        const currentHeight = $(this).find('.sub-menu').height();
        $(this).toggleClass('active');
        let autoHeight = 0;

        if($(this).find('.sub-menu').hasClass('active')) {
            autoHeight = 0;
        } else {
            $(this).find('.sub-menu').css('height', 'auto');
            autoHeight = $(this).find('.sub-menu').hasClass('active') ? 0 : $(this).find('.sub-menu').height();
        }

        $(this).find('.sub-menu').toggleClass('active');

        $(this).find('.sub-menu').height(currentHeight).animate({height: autoHeight}, 300);
    })
});

let popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
popoverTriggerList.map(function (popoverTriggerEl) {
    return new bootstrap.Popover(popoverTriggerEl)
})

const carousels = [].slice.call(document.querySelectorAll('.carousel'));
carousels.forEach(function (carousel) {
    new bootstrap.Carousel(carousel, {
        ride: 'carousel',
        interval: 5000,
        wrap: true
    });
});